import { useTravelTranslation } from '../../app/TravelLocaleContext';
import GroupTripHostIdentity from './GroupTripHostIdentity';

/**
 * Host Travel Reputation strip + host identity (AUTH54 GT54-2).
 * Host identity is rendered outside any parent trip Link by callers.
 */
export default function HostReputationStrip({
  host = null,
  averageRating = null,
  reviewCount = 0,
}) {
  const { t } = useTravelTranslation();
  const count = Number(reviewCount) || 0;
  const hasRating = count >= 1 && averageRating != null && averageRating !== '';

  let ratingText = '';
  if (hasRating) {
    const n = Number(averageRating);
    ratingText = Number.isFinite(n) ? n.toFixed(1) : String(averageRating);
  }

  return (
    <div className="host-reputation-strip" data-testid="host-reputation-strip">
      <div className="host-reputation-strip__host">
        <span className="host-reputation-strip__label">{t('travel.review.hostReputationLabel')}</span>
        <GroupTripHostIdentity host={host} />
      </div>
      {hasRating ? (
        <span className="host-reputation-strip__rating" aria-label={`${ratingText} (${count})`}>
          ★ {ratingText} ({count})
        </span>
      ) : (
        <span className="host-reputation-strip__empty">{t('travel.review.noRatingYet')}</span>
      )}
    </div>
  );
}
